<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-select v-model="searchInfo.workersId" placeholder="请选择劳务人员" clearable>
            <template #prefix>
              劳务人员
            </template>
            <el-option v-for="item in workerList" :key="item.id" :value="item.id" :label="item.contractName"></el-option>
          </el-select>
          <el-select v-model="searchInfo.lot" placeholder="请选择班组标段" clearable>
            <template #prefix>班组标段</template>
            <el-option v-for="item in lotList" :key="item.id" :value="item.dictCode" :label="item.dictName"/>
          </el-select>
        </template>
        <template #option>
          <page-button el-type="primary" @click="resetSearch">查询</page-button>
          <page-button hasPerm="laborers:attendance-add:save" el-type="success" @click="showAdd">新建</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border page-name="attendanceAdd">
          <yq-table-column label="项目名称" prop="projectName"/>
          <yq-table-column label="工地名称" prop="siteName"/>
          <yq-table-column label="班组" prop="classmateName"/>
          <yq-table-column label="标段" prop="lot" v-if="lotList.length > 0">
            <template #default="{row}">
              <span v-for="item in lotList" :key="item.id">
                <span v-if="item.dictCode === row.lot">{{item.dictName}}</span>
              </span>
            </template>
          </yq-table-column>
          <yq-table-column label="考勤时间" prop="attendanceDate">
            <template v-slot="{row}">
              <span>{{row.attendanceDate.split(" ")[0]}}</span>
            </template>
          </yq-table-column>
          <yq-table-column label="劳务人员" prop="contractName"/>
          <yq-table-column label="补卡时间" prop="replaceTime"/>
          <yq-table-column label="考勤类型" prop="attendanceType">
            <template v-slot="{row}">
              <c-custom-select value="userCode" label="dictName" :data-list="deviceTypes" v-model="row.attendanceType" read-only />
            </template>
          </yq-table-column>
<!--          <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem"-->
<!--                           :show-overflow-tooltip="false">-->
<!--            <template v-slot="{row}">-->
<!--              <table-button-group label="更多操作">-->
<!--                <table-button hasPerm="laborers:attendance-add:save" @click="toEdit(row)">编辑</table-button>-->
<!--                <table-button hasPerm="laborers:attendance-add:remove" el-type="danger" message="是否确认删除数据" @click="deleteRow(row.id)">删除</table-button>-->
<!--              </table-button-group>-->
<!--            </template>-->
<!--          </yq-table-column>-->
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>

    <el-dialog v-model="showCardReplace" title="考勤补卡" width="1" dialog-width="1" @closed="currentData = {}">
      <form-items :data="currentData" :columns="1" label-width="2.4rem" icon-width="0">
        <form-item label="劳务人员" name="workersId" :required="true" error-message="请选择劳务人员">
          <laborer-select v-model="currentData.workersId" @change="changeLaborer"/>
        </form-item>
        <form-item label="考勤日期">
          <el-date-picker style="width: 100%" type="date" format="YYYY-MM-DD" v-model="currentData.attendanceDate"  placeholder="请选择考勤日期" />
        </form-item>
        <form-item label="考勤时间">
          <el-time-picker style="width: 100%" format="HH:mm:ss" value-format="HH:mm:ss" v-model="currentData.replaceTime"  placeholder="请选择打卡时间" />
        </form-item>
        <form-item label="考勤类型">
          <el-radio-group v-model="currentData.attendanceType">
            <el-radio v-for="it in deviceTypes" :key="it.id" :value="it.userCode">{{ it.dictName }}</el-radio>
          </el-radio-group>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showCardReplace = false">取消</page-button>
        <page-button hasPerm="laborers:attendance-add:save" el-type="primary" @click="save">保存</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import {useRoute, useRouter} from "vue-router";
import commonLqApi from "@/api/dz-luqiao/luqiaoCommonApi";
import CCustomSelect from "@/views/h5/luqiao/display/c-custom-select.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import workersCardReplaceApi from "@/api/dz-luqiao/workersCardReplaceApi";
import commonApi from "@/api/commonApi";
import util from "@/util/util"
import LaborerSelect from "@/views/h5/luqiao/display/LaborerSelect.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "LAD",
  components: {
    LaborerSelect,
    FormItem, FormItems, CCustomSelect,
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      showCardReplace: false,
      workerList: [], // 劳务人员
      currentData: {},
      deviceTypes: [],
      lotList: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    // Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    this.workerList = await commonLqApi.queryWorkersNoPage()
    this.deviceTypes = await commonApi.queryDictionaryList("CLOCK_DEVICE", (await util.getUserInfo()).merchantId)
    this.resetSearch();
    this.lotList = await commonApi.queryDictionaryList("LOT", (await util.getUserInfo()).merchantId)
  },
  methods: {
    // 变更劳务人员时，根据人员查询最近一次缺卡
    changeLaborer(data) {
      if (!data || !data.id) {
        return
      }
      if (this.currentData.attendanceType !== "WORK") {
        return;
      }
      workersCardReplaceApi.getAttendanceLack({classmateId: data.classmateId, workersId: data.id}).then(res => {
        if (res !== null && !!res.targetTime) {
          let arr = res.targetTime.split(" ");
          this.currentData.attendanceDate = arr[0];
          this.currentData.replaceTime = arr[1];
        }
      })
    },
    // 新建数据
    showAdd() {
      this.currentData.attendanceType = "WORK";
      this.showCardReplace = true;
    },
    async queryList() {
      const {records, totalCount} = await workersCardReplaceApi.list(this.searchInfo)
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toEdit(row){
      this.currentData = row;
      this.showCardReplace = true;
    },
    async deleteRow(id) {
      await workersCardReplaceApi.delete(id)
      this.resetSearch();
    },
    async save(){
      this.currentData.attendanceDate = this.currentData.attendanceDate.format? this.currentData.attendanceDate.format('yyyy-MM-dd') : this.currentData.attendanceDate; // 时间标准化
      await workersCardReplaceApi.saveSubmit(this.currentData)
      this.showCardReplace = false;
      this.resetSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>